import request from "../utils/request";

export async function getRoleList() {
    return request.get("RolePermission/GetAllRoles");
  }

  export async function createRole(newRole){
    return request.post("RolePermission/CreateRole",newRole);
  }

  export async function getRolePermissions(roleId){
    return request.get("RolePermission/GetRolePermissions?roleId="+roleId)
  }

  export async function addPermission(permission){
    return request.post("RolePermission/AddPermission",permission);
  }

  export async function deleteRole(roleId){
    return request.delete("RolePermission/DeleteRole?roleId="+roleId);
  }

  export async function deletePermission(permission){
    return request.post("RolePermission/DeletePermission",permission);
  }